"use client"

import { useCallback, useRef, useEffect } from "react"

export function useChatScroll() {
  const containerRef = useRef<HTMLDivElement | null>(null)

  const scrollToBottom = useCallback(() => {
    const el = containerRef.current
    if (!el) return
    
    // Use requestAnimationFrame to ensure DOM is updated
    requestAnimationFrame(() => {
      // Ensure we hit the max scroll position precisely
      el.scrollTop = el.scrollHeight
    })
  }, [])

  const isAtBottom = useCallback(() => {
    const el = containerRef.current
    if (!el) return true
    
    // Be more tolerant to account for paddings, safe areas, and virtual keyboards
    const threshold = 320 // pixels from bottom
    return el.scrollHeight - el.scrollTop - el.clientHeight < threshold
  }, [])

  return { containerRef, scrollToBottom, isAtBottom }
}
